import type { CityConfig } from "../city-template/types";

export const mooreConfig: CityConfig = {
  city: "Moore",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "moore",
  route: "/moore",
  title: "Emergency Passport Moore, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Moore, OK — as fast as 24 hours. Serving South OKC metro, Cleveland County families. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Moore, OK",
  heroSubtitle: "Spring break in Cancun with two weeks notice and your passport expired? Business trip to Toronto from the OKC metro with no valid documents? Family vacation to Europe and you need passports for the whole crew? We help Moore and South Oklahoma City metro residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20suburban%20view%20of%20Moore%20Oklahoma%20residential%20neighborhood%20with%20modern%20homes%20and%20community%20parks%20tree-lined%20streets%20central%20Oklahoma%20landscape%20Oklahoma%20City%20skyline%20visible%20in%20distance%20wide%20open%20skies%20dramatic%20cloud%20formations%20golden%20prairie%20sunset%20light%20family-friendly%20suburb%20drone%20photography&width=1800&height=700&seq=moore-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Moore Oklahoma suburban neighborhood with OKC skyline in distance at golden hour",
  geoPosition: "35.3395;-97.4867",
  geoPlacename: "Moore, Oklahoma",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 210 miles south of Moore via I-35",
  },
  nearbyCitiesZips: [
    { name: "Moore", zips: "73160, 73170" },
    { name: "Norman", zips: "73019, 73026, 73069, 73071, 73072" },
    { name: "Oklahoma City", zips: "73102, 73103, 73104, 73106" },
    { name: "Newcastle", zips: "73065" },
    { name: "Blanchard", zips: "73010" },
    { name: "Purcell", zips: "73080" },
    { name: "Tuttle", zips: "73089" },
    { name: "Noble", zips: "73068" },
    { name: "Lexington", zips: "73051" },
    { name: "Mustang", zips: "73064" },
    { name: "Yukon", zips: "73085, 73099" },
    { name: "Midwest City", zips: "73110, 73130" },
    { name: "Del City", zips: "73115, 73135" },
    { name: "Choctaw", zips: "73020" },
    { name: "McLoud", zips: "74851" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent South OKC metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "South OKC Metro", desc: "Serving Moore, Norman, Newcastle, Blanchard, and Cleveland County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Oklahoma City, OK", route: "/oklahoma-city" },
    { name: "Fast passport renewal in Norman, OK", route: "/norman" },
    { name: "Emergency passport help in Edmond, OK", route: "/edmond" },
    { name: "Urgent passport services in Tulsa, OK", route: "/tulsa" },
    { name: "Same-day passport help in Dallas, TX", route: "/dallas" },
    { name: "Passport courier services in Lawton, OK", route: "/lawton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Moore remotely via secure courier. We do not have a walk-in office in Moore — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cleveland County and the South OKC metro.",
  fpcOfficeAddress: "211 N Robinson Ave, Oklahoma City, OK 73102",
  mapEmbedUrl: "https://www.google.com/maps?q=211+N+Robinson+Ave,+Oklahoma+City,+OK+73102&output=embed",
  fpcOfficeDistance: "Serving all of Cleveland County and the South Oklahoma City metro region including McClain and Grady counties",
  serviceAreaIntro: "From the resilient neighborhoods and family-friendly parks of Moore to the university culture of Norman and the Sooner spirit of OU, from the growing communities of Newcastle and Blanchard to the historic railroad town of Purcell, from the western suburbs of Mustang and Tuttle to the military heritage of Midwest City and Del City — Fast Passport Center serves the entire South Oklahoma City metropolitan region. We regularly help families, students, and professionals get their passports fast without the 210-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Moore neighborhoods and the surrounding South OKC metro including Norman, Oklahoma City, Newcastle, Blanchard, Purcell, Tuttle, Noble, and Mustang. If you are anywhere in Cleveland County or McClain County, we have you covered.",
  howItWorksIntro: "Most Moore travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Moore travelers often face a 3-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Moore and South OKC metro travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Moore? Here are the most common ones we hear from Cleveland County and South OKC metro travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Moore travelers with immediate departure needs — as fast as 24 hours for urgent international flights or last-minute trips.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Moore travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Moore with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Moore and South OKC metro residents with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sarah J.",
      location: "Moore, OK",
      rating: 5,
      text: "Our family trip to Cancun was in 5 days when we realized all 4 passports were expired. Fast Passport Center got them all renewed in 48 hours. From Moore to the beach — they made it happen!",
      service: "Passport Renewal",
    },
    {
      name: "Kevin M.",
      location: "Moore, OK",
      rating: 5,
      text: "Business trip to Toronto booked last minute. Fast Passport Center had my passport in 36 hours. Didn't even have to leave Moore. Incredible service for South OKC.",
      service: "Emergency Passport",
    },
    {
      name: "Rebecca T.",
      location: "Newcastle, OK",
      rating: 5,
      text: "OU son's spring break trip to Europe and his first passport was needed fast. Fast Passport Center handled everything in 4 days. Amazing for Cleveland County families!",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "moore-ok-1",
      name: "Moore Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 SW 4th St",
      city: "Moore",
      state: "OK",
      zip: "73160",
      phone: "(405) 794-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Moore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Moore facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "moore-ok-2",
      name: "Cleveland County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "200 S Peters Ave, Suite 110",
      city: "Norman",
      state: "OK",
      zip: "73069",
      phone: "(405) 366-0240",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles south in downtown Norman",
      website: "https://www.clevelandcountyok.com",
      websiteLabel: "Cleveland County Court Clerk",
      notes: "Accepts passport applications for all Cleveland County residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "moore-ok-3",
      name: "Norman Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "129 W Gray St",
      city: "Norman",
      state: "OK",
      zip: "73069",
      phone: "(405) 321-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles south of Moore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Norman and South OKC area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "moore-ok-4",
      name: "Newcastle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 NW 4th St",
      city: "Newcastle",
      state: "OK",
      zip: "73065",
      phone: "(405) 387-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southwest of Moore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Newcastle and McClain County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "moore-ok-5",
      name: "Oklahoma City — Center City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 NW 5th St",
      city: "Oklahoma City",
      state: "OK",
      zip: "73102",
      phone: "(405) 232-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles north of Moore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Downtown OKC facility. Serves the greater OKC metro area. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Moore photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cleveland County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Moore applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many South OKC families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Moore travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Moore." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Moore address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Moore before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Moore for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Moore?", a: "Fast Passport Center offers fast passport renewal in Moore in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Moore?", a: "The nearest regional passport agency to Moore is the Dallas Passport Agency, approximately 210 miles south via I-35. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Moore without any in-person agency visit required." },
    { q: "Do you serve the entire South OKC metro area?", a: "Absolutely. Fast Passport Center serves the entire South Oklahoma City metro region including Moore, Norman, Newcastle, Blanchard, Purcell, and surrounding communities. Our courier service works seamlessly from any address in Cleveland County, McClain County, or Grady County." },
    { q: "Can I get family passports in Moore on short notice?", a: "Yes. Fast Passport Center expedites family passports in Moore — we can process multiple family members simultaneously in 24–48 hours. We handle everything from child passports to adult renewals. South OKC families save hours of driving and weeks of waiting." },
    { q: "Can I expedite a child passport in Moore?", a: "Yes. Fast Passport Center expedites child passports in Moore for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Cleveland County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Moore with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Moore", address: "601 SW 19th St, Moore, OK 73160", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Moore", address: "700 SW 19th St, Moore, OK 73160", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Norman", address: "333 N Interstate Dr, Norman, OK 73069", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Norman", address: "120 12th Ave SE, Norman, OK 73071", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Moore",
      address: "2100 S I-35 Service Rd, Moore, OK 73160",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Norman",
      address: "300 N Interstate Dr, Norman, OK 73069",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cleveland County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Oklahoma City West",
      address: "7200 NW 10th St, Oklahoma City, OK 73127",
      hours: "Mon–Fri: 8AM–5PM",
      note: "OKC metro facility. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "OKC",
      name: "Will Rogers World Airport",
      distance: "12 miles northwest of Moore",
      address: "7100 Terminal Dr, Oklahoma City, OK 73159",
      note: "Major Oklahoma airport with direct flights nationwide. About 15 minutes from Moore via I-35.",
      flightUrl: "https://flyokc.com/",
      flightLabel: "OKC Airport",
      featured: true,
    },
    {
      code: "OUN",
      name: "University of Oklahoma Westheimer Airport",
      distance: "15 miles south of Moore",
      address: "1700 Lexington Ave, Norman, OK 73069",
      note: "Regional airport serving Norman and OU. Charter and general aviation services.",
      flightUrl: "https://www.fly.ou.edu/",
      flightLabel: "OUN Airport",
      featured: false,
    },
    {
      code: "DFW",
      name: "Dallas/Fort Worth International Airport",
      distance: "200 miles south of Moore",
      address: "2400 Aviation Dr, DFW Airport, TX 75261",
      note: "Major international hub with direct flights worldwide. About 3 hours from Moore via I-35.",
      flightUrl: "https://www.dfwairport.com/",
      flightLabel: "DFW Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Oklahoma birth and death certificates from the Oklahoma State Department of Health Vital Records — online, by mail, or in person at the Cleveland County Clerk.", url: "https://oklahoma.gov/health/health-education/data-and-statistics/vital-records.html" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Cleveland County Court Clerk in Norman. Required for name change passport applications.", url: "https://www.clevelandcountyok.com" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Cleveland County District Court. Required for name change passport corrections.", url: "https://www.oscn.net/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Oklahoma, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};